module.exports = __webpack_public_path__ + "static/media/vet-supply-order.4ddedbd6.svg";